module.exports = __webpack_public_path__ + "img/cloud.a32279c9.svg";